import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ToastProvider } from './components/Toast';
import { useAuth } from './hooks/useAuth';
import { queryClient } from './lib/queryClient';
import { GroupsFlagged } from './routes/GroupsFlagged';
import { GroupsNew } from './routes/GroupsNew';
import { GroupsReview } from './routes/GroupsReview';
import { List } from './routes/List';
import { Login } from './routes/Login';
import { NoAccess } from './routes/NoAccess';
import { Product } from './routes/Product';
import { Search } from './routes/Search';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}

function Shell() {
  const auth = useAuth();

  if (auth.status === 'loading') {
    return <div className="h-screen flex items-center justify-center text-text-secondary">Cargando…</div>;
  }
  if (auth.status === 'signed_out') {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
  if (auth.status === 'not_allowed') {
    return <NoAccess />;
  }

  const me = auth.me;
  return (
    <Routes>
      <Route path="/" element={<Search me={me} onSignOut={auth.signOut} />} />
      <Route path="/search" element={<List me={me} onSignOut={auth.signOut} />} />
      <Route path="/product/:productId" element={<Product me={me} onSignOut={auth.signOut} />} />
      <Route path="/groups" element={<GroupsReview me={me} onSignOut={auth.signOut} />} />
      <Route path="/groups/new" element={<GroupsNew me={me} onSignOut={auth.signOut} />} />
      <Route path="/groups/flagged" element={<GroupsFlagged me={me} onSignOut={auth.signOut} />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
